import { QueryClient } from '@tanstack/react-query';

// Configuration du client React Query
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (anciennement cacheTime)
      retry: (failureCount, error: any) => {
        // Ne pas retry pour les erreurs d'authentification
        if (error?.status === 401 || error?.status === 403) {
          return false;
        }
        // Retry max 3 fois pour les autres erreurs
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: false,
    },
  },
});

// Clés de requête pour le cache
export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  courriers: {
    all: ['courriers'] as const,
    lists: () => [...queryKeys.courriers.all, 'list'] as const,
    list: (filters: Record<string, any>) => [...queryKeys.courriers.lists(), filters] as const,
    details: () => [...queryKeys.courriers.all, 'detail'] as const,
    detail: (id: number) => [...queryKeys.courriers.details(), id] as const,
    statistics: () => [...queryKeys.courriers.all, 'statistics'] as const,
  },
  pieces: {
    all: ['pieces'] as const,
    lists: () => [...queryKeys.pieces.all, 'list'] as const,
    list: (courrierId: number) => [...queryKeys.pieces.lists(), courrierId] as const,
    details: () => [...queryKeys.pieces.all, 'detail'] as const,
    detail: (id: number) => [...queryKeys.pieces.details(), id] as const,
    ocr: (id: number) => [...queryKeys.pieces.detail(id), 'ocr'] as const,
  },
  search: {
    all: ['search'] as const,
    results: (query: string) => [...queryKeys.search.all, query] as const,
  },
  organisations: {
    all: ['organisations'] as const,
    lists: () => [...queryKeys.organisations.all, 'list'] as const,
  },
  perimeters: {
    all: ['perimeters'] as const,
    lists: () => [...queryKeys.perimeters.all, 'list'] as const,
  },
  userDefaults: {
    all: ['userDefaults'] as const,
    get: () => [...queryKeys.userDefaults.all, 'get'] as const,
  },
  notifications: {
    all: ['notifications'] as const,
    lists: () => [...queryKeys.notifications.all, 'list'] as const,
    unread: () => [...queryKeys.notifications.all, 'unread'] as const,
    unreadCount: () => [...queryKeys.notifications.all, 'unreadCount'] as const,
  },
} as const;